import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, filterObject, toObservable } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { ContrareciboDtoList } from "./listmem";
import { FiltroComponent } from "./filtro";
import { GenerarContrarecibosModalEdit, GenerarContrarecibosPPModalEdit } from "../modales";

import { FacturasToolbar } from "app/features/componentes/facturas";

interface Props2 {
    permisos: models.Rol;
}

interface State {
    filtro: models.FiltroFacturas;
    selected: number[],
    ClienteVerBotones: boolean
    IdCliente : number|null;
}

const FacturarButton = kea.defaultProps(kea.Button, { children: "Facturar guías", style: "primary", iconClass: fa("file-o") });

export class ContrareciboListNoRx extends React.PureComponent<Props2, State> {
    constructor(props: Props2) {
        super(props);
        this.state = {
            filtro: { } as models.FiltroFacturas,
            selected: [],
            ClienteVerBotones: true,
            IdCliente : null
        };
        this.state.filtro.EsFacturaLogistica= false
    }

    modalManager = kea.createModalManager();
    
    filtro = (props: Props2, state: State): models.FiltroFacturas => ({
        ...state.filtro,
        DeCredito: true,
        EsNotaCargo: false,
        EsNotaCredito: false
    });

    items = createSelectorRx(this.filtro, filtro => observeResource(resources.Factura.Query, filtro));

    private permisos = (props: Props2) => props.permisos;
    private VerFiltroSucursalEnConsultaContrarecibos = createSelectorRx(this.permisos, permisos => permisos.Cobranza.VerFiltroSucursalEnContrarecibos);

    onFiltroChange = (x: models.FiltroFacturas) => this.setState({ filtro: x });
    onSelectedChange = (x: number[]) => this.setState({ selected: x });

    seleccionado = (props: Props2, x: State) => x.selected;

    saldoTotal = createSelectorRx(this.items, this.seleccionado, (items, seleccionado) => {
        if (seleccionado.length <= 0)
            return 0;
        var saldosFiltrados = items.filter(x => seleccionado.indexOf(x.IdRegistro) != -1).map(x => x.Saldo);
        return saldosFiltrados.reduce((a, b) => a + b);
    });

    onGenerarContrarecibos = async () => {
        const result = await this.modalManager.showModal(GenerarContrarecibosModalEdit, undefined, []);
        if (result.result) {
            const folios = await resources.Cobranza2.FacturarGuiasCredito(result.value);
            kea.message("Facturas generadas", `Se generaron las facturas: ${folios.join(", ")}`, "success");
        }
    }

    GetUserId = async (id: number) => {
        const result = await resources.Cobranza2.TieneCliente(id);
        return result;
    }
    
    componentWillMount = async() => {
        const result = await this.GetUserId(this.props.permisos.IdRegistro);

        if(result.IdCliente!= null)
        {
            this.setState({
                ClienteVerBotones : result.IdCliente == null ? true : false,
                IdCliente: result.IdCliente,
                filtro: {
                    DeCredito: true,
                    EsNotaCargo: false,
                    EsNotaCredito: false,
                    TieneCliente: result.IdCliente == null ? false : true,
                    IdCliente: result.IdCliente,
                    EsFacturaLogistica: this.state.filtro.EsFacturaLogistica
                }
    
            });
        }
    }

    render() {
        var ClienteVerBotones = this.state.ClienteVerBotones
        
        const items = this.items(this.props, this.state);
        const saldoTotal = this.saldoTotal(this.props, this.state);

        const filtro = this.filtro(this.props, this.state);
        const VerFiltroSucursalEnConsultaContrarecibos = this.VerFiltroSucursalEnConsultaContrarecibos(this.props);
        return (
            <div>
                <div className="btn-group">
                    {ClienteVerBotones && <FacturarButton onClick={this.onGenerarContrarecibos} />}
                    {ClienteVerBotones && <FacturasToolbar idFacturas={this.state.selected} EsFacturaLogistica={ this.state.filtro.EsFacturaLogistica } />}
                </div>

                <FiltroComponent onChange={this.onFiltroChange} value={filtro} 
                verSucursalCobranza={VerFiltroSucursalEnConsultaContrarecibos}
                verSelectCliente={ClienteVerBotones} />

                <div className="row">
                    <div className="col-md-3">
                        <kea.Number value={saldoTotal} format="currency" label="Saldo seleccionado:" readonly />
                    </div>
                </div>

                <ContrareciboDtoList items={items} value={this.state.selected} onChange={this.onSelectedChange} />

                {this.modalManager.component}
            </div>
        );
    }
}

const ContrareciboListControlledRX = componentToRx(ContrareciboListNoRx);
class ContrareciboListControlled extends React.PureComponent<{}> {
    render() {
        return <ContrareciboListControlledRX permisos={resources.User.PermisoRx} />;
    }
}

export const ContrareciboList = ContrareciboListControlled;


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/list/list.tsx